const stopPropagation = (event) => event.stopPropagation();

export default stopPropagation;
